export const STOP_SALE_CAMPAIGNS_SSC = ['REC-S', 'REC-E'];
export const STOP_SALE_CODES_VIS = ['I', 'S'];
export const STOP_SALE_COMPLETION = 'Not Completed';
